/**
 * Staggered entrance for the auth screens. The whole effect is CSS (see the
 * `.auth-reveal*` rules in `index.css`, which also opt out under
 * `prefers-reduced-motion`) — this module only maps a step index to its class so
 * the three primitives don't each hardcode the same strings.
 *
 * Steps read top-to-bottom on screen: brand, heading, fields, submit, footer.
 */
export type AuthRevealStep = 1 | 2 | 3 | 4 | 5;

export const AUTH_REVEAL_BRAND: AuthRevealStep = 1;
export const AUTH_REVEAL_HEADING: AuthRevealStep = 2;
export const AUTH_REVEAL_FIELDS: AuthRevealStep = 3;
export const AUTH_REVEAL_SUBMIT: AuthRevealStep = 4;
export const AUTH_REVEAL_FOOTER: AuthRevealStep = 5;

export function authRevealClass(step: AuthRevealStep): string {
  return `auth-reveal auth-reveal-step-${step}`;
}
